import { OnInit, OnDestroy, Directive } from '@angular/core';
import { Observable, Subject, EMPTY } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { RecordService } from 'app/main/services/record.service';
import { DatasetActionContainerService } from 'app/main/services/datasetACS';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from '../services/app.service';

@Directive()
export abstract class BasePageDirective implements OnInit, OnDestroy{

	protected _unsubscribeAll: Subject<any>;

	constructor(
		protected route: ActivatedRoute, 
		protected router: Router, 
		public appService: AppService,
		public datasetACS: DatasetActionContainerService,
		public recordService: RecordService,
		protected translate: TranslateService){
		// unsubscription subject
		this._unsubscribeAll = new Subject();
	}

	ngOnInit(): void{
		this.recordService.recordId = this.route.snapshot.paramMap.get('recordId');
		this._load();
		// reload data with new language
		this.appService.onLanguageChange
		.pipe(takeUntil(this._unsubscribeAll))
		.subscribe((newLang) => {
			if (newLang) {
				this.recordService.unsetParam('lang');
				this._load();
			}
		});
	}

	/**
	 *	Override this with a http request
	 */
	protected load(): Observable<any>{ return EMPTY; }
	protected onLoaded(response): void{}

	private _load(): void{
		this.datasetACS.loading.next(true);
		this.load()
		.pipe(takeUntil(this._unsubscribeAll))
		.subscribe({
			next: response => {
				this.datasetACS.loading.next(false);
				this.onLoaded(response);
			},
			error: err => {
				this.datasetACS.loading.next(false);
			}
		});
	}

	ngOnDestroy(): void{
		// Unsubscribe from all subscriptions
		this._unsubscribeAll.next();
		this._unsubscribeAll.complete();
	}
}
